<!--
  E-file chart chrome: only the Highcharts context menu (hamburger) appears on
  the chart — no card-level cog, resize, or collapse icons (`ex-component-container`
  inputs). Sort/chart-type/export items live in that menu (ex-chart exporting).
-->
<div class="efile-dashboard-root" #dashboardRoot>
  <!-- Submission banner – mirrors legacy <div class="submission-details-text">. -->
  @if (submissionBannerText) {
<div class="submission-details-text">
    <div class="highlighted-text">{{ submissionBannerText }}</div>
    <div class="more-info">
      <span>For More info on the Submission Details</span>
      <button class="click-here-btn" type="button" (click)="showSubmissions()">Click here</button>
    </div>
  </div>
}

  <!-- Alert text from dashboard config (if any). -->
  @if (dashboardOptions.dashboard_alert_text) {
<div class="dashboard-alert">
    {{ dashboardOptions.dashboard_alert_text }}
  </div>
}

  <!-- Error state. -->
  @if (errorMessage && !dashboardLayoutLoading) {
<div class="dashboard-error">
    <i class="fa fa-exclamation-triangle"></i>
    <span>{{ errorMessage }}</span>
  </div>
}

  <!-- Skeleton chart grid: 3 placeholders matching typical e-file layout —
       one full-width chart row, then one row with two half-width charts. -->
  @if (dashboardLayoutLoading && !errorMessage) {
<div class="dashboard-container skeleton-container"
      >
    <div class="row">
      <div class="col-md-12">
        <div class="chart-shell skeleton-chart-shell">
          <div class="skeleton-chart-header"></div>
          <div class="chart-loader-overlay">
            <i class="fa fa-spin fa-spinner fa-2x"></i>
            <span class="chart-loader-text">Loading…</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-10">
      @for (_ of skeletonBottomRowSlots; track $index) {
<div class="col-md-6">
        <div class="chart-shell skeleton-chart-shell">
          <div class="skeleton-chart-header"></div>
          <div class="chart-loader-overlay">
            <i class="fa fa-spin fa-spinner fa-2x"></i>
            <span class="chart-loader-text">Loading…</span>
          </div>
        </div>
      </div>
}
    </div>
  </div>
}

  <!-- Component grid: one row per `dashboardOptions.components` entry,
       each row is an array of components rendered in `col-md-<columns>`
       slots, same structure as ExDashboardComponent template. -->
  @if (!dashboardLayoutLoading && !errorMessage && dashboard) {
<div class="dashboard-container">
    @for (row of dashboardOptions.components; track $index; let i = $index) {
<div class="row"
         [ngClass]="{'mt-10': i > 0}"
        >
      @if (row[0]?.row_title) {
<label class="row-header">{{ row[0].row_title }}</label>
}
      @for (component of row; track $index) {

        <div class="col-md-{{component.columns || 12}}">
          @if (component.extraOptions?.kpis?.length > 0) {
<div class="container-fluid kpi-wrap"
              >
            <div class="row kpi-container">
              @for (kpi of component.extraOptions.kpis; track $index) {
<div>
                <gtw-ex-component-resolver [options]="kpi" [hideLoader]="true"></gtw-ex-component-resolver>
              </div>
}
            </div>
          </div>
}
          <!-- chart-shell wraps the container so the per-chart loader can be
               overlaid via absolute positioning while that specific sheet
               is still in flight. `isComponentLoading(component)` flips
               independently per tile (keyed off `component.srcSheet`), so a
               slow sheet no longer keeps the rest of the dashboard's tiles
               spinning and tiles whose data has already landed don't sit
               behind a stale overlay while Highcharts mounts. -->
          <div class="chart-shell">
            <gtw-ex-component-container
              [title]="component.title"
              [height]="component.height"
              [component]="component"
              [showResize]="false"
              [showChartTypeSwitcher]="false"
              [showCollapseToggle]="false">
              <gtw-ex-component-resolver [options]="component"></gtw-ex-component-resolver>
            </gtw-ex-component-container>
            @if (isComponentLoading(component)) {
<div class="chart-loader-overlay">
              <i class="fa fa-spin fa-spinner fa-2x"></i>
              <span class="chart-loader-text">Loading…</span>
            </div>
}
          </div>
        </div>
      
}
    </div>
}
  </div>
}
</div>

<!--
  Chart-click popup. Mirrors legacy `$uibModal.open({ templateUrl:
  'app/components/efile/efileElements/dashboard-popup.html' ... })` (see
  EfileElementsController.js L1212). Rendered as an in-app overlay so it
  doesn't depend on AngularJS modal infrastructure or the upgraded
  `<gtw-efile-dashboard-popup-ce>` element.
-->
@if (showPopup) {
<div class="dashboard-popup-modal" role="dialog" aria-modal="true">
  <div class="dashboard-popup-modal-backdrop" (click)="closePopup()"></div>
  <div class="dashboard-popup-modal-dialog modal-content" (click)="$event.stopPropagation()">
    <gtw-efile-dashboard-popup
      [popup-row-data]="popupRowData"
      (request-grid-update)="closePopup($event)"
    ></gtw-efile-dashboard-popup>
  </div>
</div>
}
